import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import { type FC, useCallback, useEffect, useMemo } from "react";
import { useLocation, useParams } from "react-router";

import { FilterDropdownMultiple } from "~/components/UI/FilterDropdown";
import { useFilter } from "~/providers/FilterProvider";

import { useCategoriesFilterDropdown } from "./useCategoriesFilterDropdown";
import { useCategoriesFilterDropdownOptions } from "./useCategoriesFilterDropdownOptions";

export const CategoriesFilterDropdown: FC = () => {
  const options = useCategoriesFilterDropdownOptions();
  const { slug } = useParams();
  const { pathname } = useLocation();
  const { filters, updateFilters } = useFilter();
  const { selectedValue, onChangeExcludeFilter } =
    useCategoriesFilterDropdown();

  const getChipText = useCallback((values: string[]) => {
    if (!values.length) {
      return "All";
    }

    return `${values.length} excluded`;
  }, []);

  const isCategoryPage = useMemo(
    () => Boolean(pathname?.startsWith("/category") && slug),
    [pathname, slug]
  );

  useEffect(() => {
    if (!isCategoryPage) return;
    if (!filters.excludeCategoryIds?.length) return;
    updateFilters({ excludeCategoryIds: undefined });
  }, [filters.excludeCategoryIds?.length, isCategoryPage, updateFilters]);

  if (isCategoryPage) return null;

  return (
    <FilterDropdownMultiple
      label="Category"
      icon={<SellOutlinedIcon fontSize="inherit" />}
      options={options}
      value={selectedValue}
      onChange={onChangeExcludeFilter}
      minOptionCount={1}
      exclude
      getChipText={getChipText}
    />
  );
};
